// import _isEmpty from 'lodash/isEmpty';
import _assign from 'lodash/assign';
import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.problems, action) => {
  switch (action.type) {
    case `${ActionTypes.GET_PROBLEMS}_SUCCESS`: {
      const incomingRaw = action.payload;
      const incoming = Array.isArray(incomingRaw)
        ? incomingRaw
        : Array.isArray(incomingRaw?.results)
        ? incomingRaw.results
        : [];
      if (!incoming.length) return state;

      const existingGroups = Array.isArray(state.cached) ? state.cached : [];
      const existingSlugs = new Set(
        existingGroups.flatMap(g => (Array.isArray(g?.keys) ? g.keys : []))
      );

      const newProblems = incoming.filter(
        p => p?.slug && !existingSlugs.has(p.slug)
      );
      if (!newProblems.length) return state;

      const nextGroups = existingGroups.length
        ? existingGroups.concat([
            { problems: newProblems, keys: newProblems.map(p => p.slug) },
          ])
        : [{ problems: newProblems, keys: newProblems.map(p => p.slug) }];

      return _assign({}, state, { cached: nextGroups });
    }
    case `${ActionTypes.SET_PROBLEMS_GROUP}_SUCCESS`: {
      return _assign({}, state, { sectionsGrouped: action.payload });
    }
    case ActionTypes.INDEX_PROBLEMS: {
      return {
        ...state,
        indexedProblems: action.payload.indexedProblems,
      };
    }
    case ActionTypes.SLUG_CHANGE_FROM_ROUTER: {
      return {
        ...state,
        slugChangeFromRouter: action.slugChangeFromRouter,
      };
    }
    default:
      return state;
  }
};
